import api from "./axios";
import { API_BASE_URL } from "./baseUrl";

// Customer-side endpoints (auth: customer user). Backend resolves which
// business this customer is linked to and returns its drive.
export const listMyFiles = (params = {}) => api.get("/my/files", { params });
export const getMyFile = (id) => api.get(`/my/files/${id}`);

// Admin drive — keyed off a business id, not a customer user. A business
// can carry files even before "Grant login" has been used.
export const listBusinessFiles = (businessId, params = {}) =>
  api.get(`/businesses/${businessId}/files`, { params });
export const uploadBusinessFile = (businessId, formData) =>
  api.post(`/businesses/${businessId}/files`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
export const deleteBusinessFile = (businessId, fileId) =>
  api.delete(`/businesses/${businessId}/files/${fileId}`);
export const bulkDeleteBusinessDrive = (businessId, payload) =>
  api.post(`/businesses/${businessId}/files/bulk-delete`, payload);
export const renameBusinessFile = (businessId, fileId, name) =>
  api.patch(`/businesses/${businessId}/files/${fileId}`, { name });
export const updateBusinessFile = (businessId, fileId, payload) =>
  api.patch(`/businesses/${businessId}/files/${fileId}`, payload);

// Folders (admin only)
export const createBusinessFolder = (businessId, payload) =>
  api.post(`/businesses/${businessId}/folders`, payload);
export const updateBusinessFolder = (businessId, folderId, payload) =>
  api.patch(`/businesses/${businessId}/folders/${folderId}`, payload);
export const deleteBusinessFolder = (businessId, folderId) =>
  api.delete(`/businesses/${businessId}/folders/${folderId}`);

export const fileDownloadUrl = (fileId) => {
  const base = API_BASE_URL;
  const token = localStorage.getItem("access_token");
  return { url: `${base}/customer-files/${fileId}/download`, token };
};

export const downloadFile = async (fileId, filename) => {
  const { url, token } = fileDownloadUrl(fileId);
  const res = await fetch(url, { headers: { Authorization: `Bearer ${token}` } });
  if (!res.ok) throw new Error("Download failed");
  const blob = await res.blob();
  const blobUrl = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = blobUrl;
  a.download = filename || "download";
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(blobUrl);
};
